export default "__VITE_ASSET__0y$v64yw__"